import { smsGlobalGraphQLClient } from '@/composables/default-urql-client'
import {
    formatFilter,
    formatPaginationData,
    formatSort,
    parsePaginationParam,
    QueryKeys,
    QueryParams,
    useListQueryParams,
} from '@/composables/helpers'
import { RouteQueryPrefix } from '@/composables/route'
import httpClient from '@/utils/httpClient'
import { useMutation, useQuery, useQueryClient } from '@tanstack/vue-query'
import gql from 'graphql-tag'
import { computed, ref, watchEffect } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { toast } from 'vue-sonner'

export const useAddSMSGlobalServerMutation = () => {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: async (form: any) => {
            return await httpClient.post(`v1/sms-global/servers`, form)
        },
        onSuccess: () => {
            queryClient
                .invalidateQueries({
                    queryKey: [QueryKeys.SMSGlobal],
                })
                .then(() => {})

            toast.success('SMS Global Server created successfully.', {
                position: 'top-center',
                closeButton: false,
            })
        },
    })
}

export const useSMSListQuery = (params?: QueryParams) => {
    const route = useRoute()
    const serverUuid = route.params.serverId
    const enabled = ref(true)
    const staleTime = ref(1000 * 60 * 5)
    const { key, page, limit, sort, filter, q, groupBy } = useListQueryParams(params)

    watchEffect(() => {
        if (params?.staleTime?.value) {
            staleTime.value = params.staleTime.value
        }

        if (params?.enabled?.value) {
            enabled.value = params.enabled.value
        }
    })

    return useQuery({
        queryKey: [QueryKeys.SMS, QueryKeys.Paginated, key],
        queryFn: async () => {
            const { data } = await httpClient.get(`v1/sms-global/${serverUuid}/sms`, {
                params: {
                    page: page.value,
                    limit: limit.value,
                    sort: sort.value,
                    filter: filter.value,
                    q: q.value,
                    group_by: groupBy.value,
                },
            })

            return data
        },
        enabled: enabled.value,
        staleTime: staleTime.value,
    })
}

export const useSendSMSMutation = () => {
    const queryClient = useQueryClient()
    const route = useRoute()
    const serverUuid = route.params.serverId

    return useMutation({
        mutationFn: async (form: any) => {
            return await httpClient.post(`v1/sms-global/${serverUuid}/sms`, {
                recipient: form.recipient,
                message: form.message,
                store: form.store,
            })
        },
        onSuccess: () => {
            queryClient
                .invalidateQueries({
                    queryKey: [QueryKeys.SMS],
                })
                .then(() => {})

            toast.success('Message sent.', {
                position: 'top-center',
                closeButton: false,
            })
        },
    })
}
